import React from "react"
import { formatMoney, formatDateTime } from "./format"
import { MerchantCell } from "../shared/MerchantLabel"

// Responsive ledger: a real table on md+ (sticky header), stacked cards on
// small screens (ui-ux-pro-max responsive-table pattern).
export function TransactionsTable({ rows, copy, detailBasePath }) {
  return (
    <>
      {/* Desktop / tablet table */}
      <div className="hidden overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800 md:block">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-800 text-sm">
          <thead className="sticky top-0 bg-gray-50 dark:bg-gray-800/50">
            <tr className="text-left text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              <th className="px-4 py-3">{copy.columns.type}</th>
              <th className="px-4 py-3">{copy.columns.app}</th>
              <th className="px-4 py-3">{copy.columns.shop}</th>
              <th className="px-4 py-3 text-right">{copy.columns.net}</th>
              <th className="px-4 py-3 text-right">{copy.columns.fee}</th>
              <th className="px-4 py-3 text-right">{copy.columns.gross}</th>
              <th className="px-4 py-3">{copy.columns.processedAt}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100 dark:divide-gray-800 bg-white dark:bg-gray-900">
            {rows.map((r) => (
              <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-gray-800">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-gray-100">{r.type}</td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">{r.app || "—"}</td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  <MerchantCell name={r.name} shop={r.shop} merchantId={r.merchant_id} detailBasePath={detailBasePath} />
                </td>
                <td className="px-4 py-3 text-right tabular-nums text-gray-900 dark:text-gray-100">{formatMoney(r.net_cents, r.currency)}</td>
                <td className="px-4 py-3 text-right tabular-nums text-gray-500 dark:text-gray-400">{formatMoney(r.fee_cents, r.currency)}</td>
                <td className="px-4 py-3 text-right tabular-nums text-gray-700 dark:text-gray-300">{formatMoney(r.gross_cents, r.currency)}</td>
                <td className="px-4 py-3 whitespace-nowrap text-gray-500 dark:text-gray-400">{formatDateTime(r.processed_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile cards */}
      <div className="space-y-3 md:hidden">
        {rows.map((r) => (
          <div key={r.id} className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
            <div className="flex items-start justify-between">
              <div>
                <div className="font-medium text-gray-900 dark:text-gray-100">{r.type}</div>
                <div className="text-xs text-gray-500 dark:text-gray-400">{r.app || "—"}</div>
              </div>
              <div className="text-right tabular-nums font-semibold text-gray-900 dark:text-gray-100">
                {formatMoney(r.net_cents, r.currency)}
              </div>
            </div>
            <dl className="mt-3 grid grid-cols-2 gap-y-1 text-xs text-gray-600 dark:text-gray-400">
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.shop}</dt>
              <dd className="text-right">
                <MerchantCell
                  name={r.name}
                  shop={r.shop}
                  merchantId={r.merchant_id}
                  detailBasePath={detailBasePath}
                  primaryClassName="truncate text-sm text-gray-900 dark:text-gray-100"
                  secondaryClassName="truncate text-xs text-gray-400 dark:text-gray-500"
                />
              </dd>
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.fee}</dt>
              <dd className="text-right tabular-nums">{formatMoney(r.fee_cents, r.currency)}</dd>
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.gross}</dt>
              <dd className="text-right tabular-nums">{formatMoney(r.gross_cents, r.currency)}</dd>
              <dt className="text-gray-400 dark:text-gray-500">{copy.columns.processedAt}</dt>
              <dd className="text-right">{formatDateTime(r.processed_at)}</dd>
            </dl>
          </div>
        ))}
      </div>
    </>
  )
}
